export default {"gitHash":"7fd425c7fa86bb67e59e1258b22882c7f1aa0c3a","gitHashShort":"7fd425c","time":1650116145846,"platform":"linux","arch":"x64"};